import React, { FC } from "react";
import clsx from "clsx";

import Portal from "../../Portal";

import styles from "./Modal.module.scss";

type Props = {
  children: React.ReactNode;
  className?: string;
  isTransparentBackground?: boolean;
  onClose: () => void;
};

const Modal: FC<Props> = ({
  children,
  className,
  isTransparentBackground,
  onClose,
}) => {
  return (
    <Portal>
      <div className={styles.modal}>
        <div
          className={clsx(
            styles.overlay,
            isTransparentBackground && styles.isTransparentBackground,
          )}
          onClick={onClose}
        />
        <div className={clsx(styles.content, className)}>{children}</div>
      </div>
    </Portal>
  );
};

export default Modal;
